import { render } from "./LinkRow.vue?vue&type=template&id=949d4124"
import script from "./LinkRow.vue?vue&type=script&lang=js"
export * from "./LinkRow.vue?vue&type=script&lang=js"

import "./LinkRow.vue?vue&type=style&index=0&id=949d4124&lang=css"

import exportComponent from "/root/dirif/prod/dirif-fo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__